import React from 'react';
import { aboutContent } from '../../data/mock';

const AboutSection = () => {
  return (
    <section id="rolunk" className="py-24 bg-soft-gray">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-12">
            <p className="font-montserrat text-sm uppercase tracking-[0.2em] text-warm-sage mb-4">
              Ismerj meg minket
            </p>
            <h2 className="font-playfair text-3xl md:text-4xl text-charcoal">
              {aboutContent.title}
            </h2>
          </div>

          {/* Content */}
          <div className="bg-white rounded-lg p-8 md:p-12 shadow-sm">
            <div className="relative">
              {/* Decorative Quote */}
              <span className="absolute -top-4 -left-2 font-playfair text-6xl text-warm-sage/20">
              
              </span>
              
              <div className="space-y-6">
                {aboutContent.paragraphs.map((paragraph, index) => (
                  <p
                    key={index}
                    className="font-montserrat text-base text-warm-gray leading-relaxed first:text-charcoal first:text-lg"
                  >
                    {paragraph}
                  </p>
                ))}
              </div>

              {/* Signature */}
              <div className="mt-10 pt-6 border-t border-soft-taupe/30">
                <p className="font-playfair text-xl text-charcoal italic">
                  A NekedSzedtem csapata
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
